function hashCode(s) {
    return !!s && s.split("").reduce(function(a, b) {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return a & a;
    }, 0);
    // Поставить setTimeout на удаление
}
export function getHashJsonWithoutObject(...arg){
    return  hashCode(JSON.stringify(...arg, function (k, v) { return k && v && typeof v !== "number" ? (Array.isArray(v) ? "[object Array]" : "" + v) : v; }));

}
function replacer(key, value) {
    return  value.replace(/\t/gi, '');
}

export function getHash(string){
    return hashCode(string)
}

export function getHashJsonStringifyObject(...arg){
    return  hashCode(JSON.stringify(...arg,null,'\t'));
}
